import { render, staticRenderFns } from "./buscarUsuarios.vue?vue&type=template&id=1c5b2919&scoped=true&"
import script from "./buscarUsuarios.vue?vue&type=script&lang=js&"
export * from "./buscarUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./buscarUsuarios.vue?vue&type=style&index=0&id=1c5b2919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b2919",
  null
  
)

export default component.exports